import { Link } from "react-router-dom";
import { Gauge, Fuel, Cog, Calendar, Heart } from "lucide-react";
import { resolveImg } from "@/lib/api";
import { useFavorites } from "@/context/FavoritesContext";

export function formatPrice(p) {
  return new Intl.NumberFormat("fr-FR").format(p) + " €";
}
export function formatKm(k) {
  return new Intl.NumberFormat("fr-FR").format(k) + " km";
}

export function VehicleCard({ vehicle }) {
  const { isFavorite, toggle } = useFavorites();
  const fav = isFavorite(vehicle.id);
  const img = resolveImg(vehicle.images?.[0]) || "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1200";

  const onHeart = (e) => { e.preventDefault(); e.stopPropagation(); toggle(vehicle.id); };

  return (
    <Link
      to={`/vehicules/${vehicle.id}`}
      data-testid={`vehicle-card-${vehicle.id}`}
      className="group block bg-[#121212] border border-white/10 rounded-sm overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-white/25 hover:shadow-[0_20px_60px_-20px_rgba(197,160,89,0.25)]"
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-black">
        <img src={img} alt={`${vehicle.brand} ${vehicle.model}`} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <button
          data-testid={`fav-toggle-${vehicle.id}`}
          onClick={onHeart}
          aria-label="Ajouter aux favoris"
          className="absolute top-3 left-3 h-9 w-9 flex items-center justify-center rounded-full bg-black/50 backdrop-blur-sm border border-white/15 hover:bg-black/70 transition-colors active:scale-90"
        >
          <Heart className={`h-4 w-4 transition-colors ${fav ? "fill-[#D92D20] text-[#D92D20]" : "text-white"}`} />
        </button>
        {vehicle.status !== "disponible" && (
          <span className="absolute top-3 right-3 bg-[#D92D20] text-white text-xs font-semibold px-3 py-1 rounded-sm uppercase tracking-wider">Vendu</span>
        )}
        <div className="absolute bottom-0 inset-x-0 h-20 bg-gradient-to-t from-black/80 to-transparent" />
        <span className="absolute bottom-3 right-3 bg-[#C5A059] text-black text-sm font-bold px-3 py-1 rounded-sm">{formatPrice(vehicle.price)}</span>
      </div>
      <div className="p-5">
        <p className="text-xs uppercase tracking-[0.2em] text-[#C5A059] mb-1">{vehicle.brand}</p>
        <h3 className="font-display text-xl font-semibold text-white leading-tight">{vehicle.model}</h3>
        <div className="mt-4 grid grid-cols-2 gap-y-2 gap-x-3 text-sm text-neutral-400">
          <span className="flex items-center gap-2"><Calendar className="h-4 w-4 text-neutral-500" />{vehicle.year}</span>
          <span className="flex items-center gap-2"><Gauge className="h-4 w-4 text-neutral-500" />{formatKm(vehicle.mileage)}</span>
          <span className="flex items-center gap-2"><Fuel className="h-4 w-4 text-neutral-500" />{vehicle.fuel}</span>
          <span className="flex items-center gap-2"><Cog className="h-4 w-4 text-neutral-500" />{vehicle.transmission}</span>
        </div>
      </div>
    </Link>
  );
}
